module.exports = __webpack_public_path__ + "static/tt-aus-logo-97cc26a8602643eddf9cfe94ca65d698.png";